export const SUPER_ADMIN_ROLE = 1;
export const SUPER_TENANT = "SuperTenant";
export const ROLES = {
  SUPER_ADMIN: "Super Admin",
  ADMIN: "Admin",
  EXECUTIVE: "Executive",
  SALES_MANAGER: "Sales Manager",
  USER: "User",
};
export const FACEBOOK_LINK =
  "https://www.facebook.com/people/AFP-Horizon/61552355196086/?mibextid=LQQJ4d";
export const TWITTER_LINK = "https://x.com/afpHorizon";
export const INSTAGRAM_LINK = "https://www.instagram.com/afphorizon/";
export const LINKEDIN_LINK = "https://www.linkedin.com/company/afp-horizon";
export const AFP_HORIZON_WEBSITE = process.env.REACT_APP_AFP_HORIZON_WEBSITE || 'https://afphorizonddev.wpenginepowered.com/';
export const AFP_HORIZON_PRIVACY_POLICY_LINK = process.env.REACT_APP_AFP_HORIZON_PRIVACY_POLICY_LINK || 'https://afphorizonddev.wpenginepowered.com/privacy-policy/';
export const MODULES = {
  DASHBOARD: "Dashboard",
  PROVIDER_MANAGEMENT: "Provider Management",
  PROVIDER_PROFILES: "Provider Profiles",
  PROVIDER_REQUESTS: "Provider Requests",
  PLANNER_MANAGEMENT: "Planner Management",
  PLANNER_PROFILES: "Planner Profiles",
  PLANNER_REQUESTS: "Planner Requests",
  SERVICE_MANAGEMENT: "Service Management",
  BOOKING_AND_APPOINTMENT: "Contract Orders",
  SERVICE_LIST: "Service List",
  PROFILE_MANAGEMENT: "Profile Management",
  USER_MANAGEMENT: "User Management",
  COMMUNICATION_MANAGEMENT: "Communication Management",
  ORDER_MANAGEMENT: "Order Management",
}


export const BUSINESS_TYPE_PLANNER = "Preneed Planner";


export const PROVIDER_BUSINESS_TYPES = [
  "Funeral & Memorial Service Providers",
  "Aftercare & Grief Support",
  "Transportation & Logistics",
  "Products & Supplies",
  "Cremation Services",
  "Technology & Media",
  "Religious & Cultural Services",
  "Vendor Services",
];

export const CONTRACT_ACTION_TYPE = {
  ADD_TEMPLATE: 'add_template',
  EDIT_TEMPLATE: 'edit_template',
}

export const CONTRACT_MANAGEMENT_TYPE = {
  PROVIDER: "provider",
  PRENEED_PLANER: "preneed_planner",
}
export const PROVIDER_DASHBOARD_CONTRACT = "/provider-dashboard/contract-template"
export const PLANER_DASHBOARD_CONTRACT = "/planner-dashboard/contract-template"
